export const AboutProperty = ({ PropertyData }) => {
  return (
    <>
      <div className="bg-white rounded-2xl border font-medium text-lg text-gray-500 border-gray-200 p-5 md:p-6 my-6">
        <h2 className="text-xl font-bold text-[#171717] mb-3">
          About this home
        </h2>

        <div className="text-gray-500 text-base font-normal">
          {PropertyData?.discription}
        </div>
      </div>
    </>
  );
};
